import { render, staticRenderFns } from "./TrafficWeekdayForm.vue?vue&type=template&id=67b14077&"
import script from "./TrafficWeekdayForm.vue?vue&type=script&lang=js&"
export * from "./TrafficWeekdayForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports